import * as R from "ramda";
import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { showNotification } from "react-admin";
import Button from "@material-ui/core/Button";
import { Formik, Field, Form } from "formik";
import { TextField } from "formik-material-ui";
import * as Yup from "yup";
import { dataProvider } from "../../App";
import { CHANGE_PASSWORD } from "../../misc/constants";

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  },
  button: { margin: "1em" },
  block: { width: "25%" }
});

const PasswordForm = ({ submitForm, isSubmiting, classes }) => {
  return (
    <Form>
      <Field
        name="oldPassword"
        type="password"
        label="Old Password"
        component={TextField}
      />
      <br />
      <Field
        name="newPassword"
        type="password"
        label="New Password"
        component={TextField}
      />
      <br />
      <Field
        name="password2"
        type="password"
        label="Confirm Password"
        component={TextField}
      />
      <br />
      <Button
        variant="contained"
        className={classes.button}
        color="primary"
        disabled={isSubmiting}
        onClick={submitForm}
      >
        Change my password
      </Button>
    </Form>
  );
};

const validationSchema = Yup.object().shape({
  oldPassword: Yup.string()
    .min(2, "Too short!")
    .required("Required"),
  newPassword: Yup.string()
    .min(2, "Too short!")
    .required("Required")
    .notOneOf([Yup.ref("oldPassword")], "Password has to differ from old"),
  password2: Yup.string()
    .min(2, "Too short!")
    .required("Required")
    .oneOf([Yup.ref("newPassword"), null], "Passwords don`t match")
});

class ChangePasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showForm: false };
    this.showPasswordForm = this.showPasswordForm.bind(this);
    this.changePass = this.changePass.bind(this);
  }

  showPasswordForm() {
    this.setState({ showForm: !this.state.showForm });
  }

  changePass(values, { setSubmitting }) {
    dataProvider(CHANGE_PASSWORD, undefined, values)
      .then(() => {
        setSubmitting(false);
        this.props.showNotification("Password has been changed!", "info");
        this.setState({ showForm: false });
      })
      .catch(({ body }) => {
        setSubmitting(false);
        const message = R.pathOr(null, ["message"], body);
        if (!message) return;
        this.props.showNotification(message, "warning");
        throw Promise.reject();
      });
  }

  getForm() {
    if (!this.state.showForm) return null;
    const PwdForm = withStyles(styles)(PasswordForm);

    return (
      <Formik
        validationSchema={validationSchema}
        render={props => <PwdForm {...props} />}
        onSubmit={this.changePass}
      />
    );
  }

  render() {
    return (
      <div>
        <Button
          variant="raised"
          onClick={this.showPasswordForm}
          className={this.props.classes.button}
        >
          Change password
        </Button>
        <div className={this.props.classes.block}>{this.getForm()}</div>
      </div>
    );
  }
}

export default connect(
  null,
  {
    showNotification
  }
)(withStyles(styles)(ChangePasswordForm));
